export default "__VITE_ASSET__CSOf8LgV__"